import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { delay } from '@core/utils/delay';
var VerificationCodeComponent = /** @class */ (function () {
    function VerificationCodeComponent() {
        this.next = new EventEmitter();
    }
    VerificationCodeComponent.prototype.onKeyDown = function (event, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, newValue, value;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = event.target;
                        input.value = input.value.replace(/[^0-9]/g, '').substring(0, 6);
                        if (['Backspace'].includes(event.key)) {
                            newValue = input.value.substring(0, input.value.length - 1);
                            this.verificationCodeForm.controls[index].setValue(newValue || null);
                            if (input.value.length === 0) {
                                this.setFocusOnElement(index - 1);
                            }
                            event.stopPropagation();
                            event.preventDefault();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, delay(0)];
                    case 1:
                        _a.sent();
                        if (['ArrowLeft'].includes(event.key)) {
                            this.setFocusOnElement(index - 1);
                            return [2 /*return*/];
                        }
                        if (['ArrowRight'].includes(event.key)) {
                            this.setFocusOnElement(index + 1);
                            return [2 /*return*/];
                        }
                        if (['Enter'].includes(event.key) && this.verificationCodeForm.valid) {
                            this.next.emit();
                            return [2 /*return*/];
                        }
                        if (input.value.length === 1) {
                            this.setFocusOnElement(index + 1);
                            return [2 /*return*/];
                        }
                        if (input.value.length === 6) {
                            this.verificationCodeForm.setValue(input.value.split(''));
                            this.setFocusOnElement(5);
                            this.next.emit();
                            return [2 /*return*/];
                        }
                        value = input.value.slice(0, 6).split('');
                        do {
                            this.setFocusOnElement(index);
                            this.verificationCodeForm.controls[index++].setValue(value.shift());
                        } while (value.length && index < 6);
                        return [2 /*return*/];
                }
            });
        });
    };
    VerificationCodeComponent.prototype.setFocusOnElement = function (index) {
        var elements = document.getElementsByName("verification-code-" + index);
        if (elements && elements.length) {
            elements[0].focus();
        }
    };
    VerificationCodeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(0)];
                    case 1:
                        _a.sent();
                        this.setFocusOnElement(0);
                        return [2 /*return*/];
                }
            });
        });
    };
    return VerificationCodeComponent;
}());
export { VerificationCodeComponent };
